import Result from "@/core/common/Result";
import {
  IBuscarVoucherUseCase,
  IBuscarVoucherUseCaseOutput
} from "../ports/ListarVoucherUsecase";
import { inject, injectable } from "inversify";
import "reflect-metadata";
import {
  type IListarVoucherGateway,
  listarVoucherGatewayDI
} from "../ports/ListarVoucherGateway";

@injectable()
export class ListarVoucherUsecaseAdapter implements IBuscarVoucherUseCase {
  @inject(listarVoucherGatewayDI)
  private readonly gateway!: IListarVoucherGateway;

  async getVoucher(): Promise<Result<IBuscarVoucherUseCaseOutput>> {
    const response = await this.gateway.getVoucher();

    if (response.isFailure) return Result.fail(response.error);

    const value = response.getValue();

    return Result.ok({
      id: value.voucherId,
      start: value.dataPrimeiraVisualizacao
    });
  }
}
